"use strict";

angular.module("internal.exams").controller("InternalExamPublicLookup", [
    "$scope",
    "EXLookupColumn",
    "$window",
    function ($scope, EXLookupColumn, $window) {

        $scope.loading = true;

        $scope.filtersOption = [];
        $scope.resultsOption = [];
        $scope.detailsOption = [];

        $scope.filtersSelect = [];
        $scope.resultsSelect = [];
        $scope.detailsSelect = [];

        $scope.saveMessage = null;

        EXLookupColumn.get().then(function (LookupColumns) {
            EXLookupColumn.getenterpriselookupcolumns().then(function (EnterpriseLookupColumns) {
                var selects = EnterpriseLookupColumns.records;
                var records = LookupColumns.records;
                var temp = null;
                for (var x in records) {
                    if (records[x].filters) {
                        for (var y in selects) {
                            if ((selects[y].examLookupColumnId == records[x].id) && selects[y].filters) {
                                temp = {}
                                temp.id = records[x].id;
                                temp.field = records[x].field;
                                temp.name = records[x].name;
                                temp.sort_order = selects[y].sortOrder;
                                temp.filters = true;
                                temp.results = false;
                                temp.details = false;
                                $scope.filtersSelect.push(angular.copy(temp));
                            }
                        }
                        delete records[x].sortOrder;
                        $scope.filtersOption.push(angular.copy(records[x]));
                    }
                    if (records[x].results) {
                        for (var y in selects) {
                            if ((selects[y].examLookupColumnId == records[x].id) && selects[y].results) {
                                temp = {}
                                temp.id = records[x].id;
                                temp.field = records[x].field;
                                temp.name = records[x].name;
                                temp.sort_order = selects[y].sortOrder;
                                temp.filters = false;
                                temp.results = true;
                                temp.details = false;
                                $scope.resultsSelect.push(angular.copy(temp));
                            }
                        }
                        delete records[x].sortOrder;
                        $scope.resultsOption.push(angular.copy(records[x]));
                    }
                    if (records[x].details) {
                        for (var y in selects) {
                            if ((selects[y].examLookupColumnId == records[x].id) && selects[y].details) {
                                temp = {}
                                temp.id = records[x].id;
                                temp.field = records[x].field;
                                temp.name = records[x].name;
                                temp.sort_order = selects[y].sortOrder;
                                temp.filters = false;
                                temp.results = false;
                                temp.details = true;
                                $scope.detailsSelect.push(angular.copy(temp));
                            }
                        }
                        delete records[x].sortOrder;
                        $scope.detailsOption.push(angular.copy(records[x]));
                    }
                }
            });
            $scope.loading = false;
        });


        $scope.save = function () {
            $scope.saving = true;
            $scope.selected = $scope.filtersSelect.concat($scope.resultsSelect).concat($scope.detailsSelect);
            for (var x in $scope.selected) { $scope.selected[x].sortOrder = $scope.selected[x].sort_order; }
            var wrapped = { 'EnterpriseExamLookupColumns': $scope.selected }

            EXLookupColumn.save(wrapped).then(function (PublicLookup) {
                $scope.saving = false;
                if (PublicLookup != null) {
                    $scope.saveMessage = "Record updated successfully";
                    $window.scrollTo(0, 0);
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };

        $scope.selectChange = function (selected, type) {
            for (var x in selected) {
                if (type == 'filters') { selected[x].filters = true; selected[x].results = false; selected[x].details = false; }
                if (type == 'results') { selected[x].filters = false; selected[x].results = true; selected[x].details = false; }
                if (type == 'details') { selected[x].filters = false; selected[x].results = false; selected[x].details = true; }
            }
            if (type == 'filters') { $scope.filtersSelect = selected }
            if (type == 'results') { $scope.resultsSelect = selected }
            if (type == 'details') { $scope.detailsSelect = selected }
        };
    }
]);